import { Icon } from '@aqarmap/aqarmap-ui';
import { useTranslation } from 'react-i18next';
import { formatNumber } from '~/lib';

export default function WalletBalance({ balance }: { balance: number }) {
  const { t } = useTranslation('app');

  return (
    <div className="flex gap-2x items-center border-b border-gray pb-3x md:border-0 md:pb-0 ">
      <div className="flex w-[40px] h-[40px] rounded-[8px] bg-[#C9C6C573] justify-center items-center">
        <Icon name="wallet" size="24px" className="text-gray__dark_2" />
      </div>
      <div className="flex flex-col">
        <span className="text-body_2 text-gray__dark_2">
          {t('currentBalance')}
        </span>
        <div className="flex gap-0.5x items-center text-title_3 text-black font-semibold ">
          <span className="text-title_3">
            {formatNumber(balance) ?? balance}
          </span>
          <span className="text-title_4"> {t('pound')}</span>
        </div>
      </div>
    </div>
  );
}
